import { DestroyRef, NgZone, inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { from, map, skipWhile } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AuthenticatedUser, AuthenticationService } from '../services/authentication.service';

export const superAdminOnlyCanActivateGuard: CanActivateFn = (route, state) => {
  const authenticationService: AuthenticationService = inject(AuthenticationService);
  const router: Router = inject(Router);
  const destroyRef: DestroyRef = inject(DestroyRef);
  const zone: NgZone = inject(NgZone);

  return from(
    authenticationService.currentUser$.pipe(
      skipWhile((user: AuthenticatedUser | null | undefined) => user === undefined),
      takeUntilDestroyed(destroyRef),
      map((user: AuthenticatedUser | null | undefined) => {
        if (user && user.isSystemAdmin) {
          return true;
        } else {
          zone.run(() => {
            console.info('Redirecting to /unauthorised');
            router.navigate(['/unauthorised']);
          });
          return false;
        }
      }),
    ),
  );
};
